import { render, staticRenderFns } from "./MetadadosCampoDinamicoPercentual.vue?vue&type=template&id=a1ea6a2a&"
import script from "./MetadadosCampoDinamicoPercentual.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoPercentual.vue
// module id = 1348
// module chunks = 28